import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const NoticeBoardSection = () => {
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    axios.get("JSON/notice.json").then((response) => {
      setNotices(response.data.reverse());
    });
  }, []);
  return (
    <>
      <div className="eschool-about-notice-main">
        <div className="eschool-about-notice-board">
          <h3 className="eschool-about-notice-title">School Notice Board</h3>
          <div className="eschool-notice-borad-box">
            <div className="eschool-n-borad-box-top">
              <ul className="eschool-n-borad-top-list">
                <li className="date-time">Date & Time</li>
                <li className="notice-details">Notice Details</li>
                <li className="action-btn">Action</li>
              </ul>
            </div>
            <div className="eschool-n-borad-details">
              {notices?.slice(0, 5).map((notice) => (
                <div className="eschool-n-borad-single-box" key={notice.id}>
                  <ul className="eschool-n-borad-single-list">
                    <li className="notice-list-date">
                      {notice?.date}, {notice?.time}
                    </li>
                    <li className="notice-list-description">{notice?.title}</li>
                    <li className="notice-list-action">
                      <a href={notice?.file} target="blank">
                        <i className="fi fi-rr-eye"></i>
                      </a>
                      <a href={notice?.file} download>
                        <i className="fi fi-sr-download"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="eschool-about-notice-btn">
          <Link to="/noticeboard" className="eschool-btn">
            View all notice
          </Link>
        </div>
      </div>
    </>
  );
};

export default NoticeBoardSection;
